/* eslint-disable */
export default {
  header: '關閉錯誤追蹤',
  content: '關閉錯誤追蹤模式將會刪除目前所有的錯誤記錄。是否要繼續？',
  confirm: '關閉',
  cancel: '取消',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
